// extracted by mini-css-extract-plugin
export default {"hide":"BurgerMenu_hide__UQDeg","burger":"BurgerMenu_burger__SD5qn"};